import { createSelector, createFeatureSelector } from '@ngrx/store';
import { State } from './transactions.reducer';
import { TransactionsFilter, TransactionsDetailsResponsePayload, TransactionsData } from './transactions.models';
import { DatesInterval } from '../../global/interfaces';
import * as moment from 'moment';
import { formatDate } from '../../global/dates';
import { formatDateUTC } from '../../global/utilities.service';

export const selectTransactionsState = createFeatureSelector<State>('transactions');

// export const selectTransactionsData = createSelector(selectTransactionsState, (state: State) =>
//   (state && state.data) ? state.data : undefined
// );

export const selectTransactionsData = createSelector(selectTransactionsState, (state: State) => {
  return (state && state.data) ? state.data : undefined;
});

export const selectTransactionsLoading = createSelector(selectTransactionsState, (state: State) => state.loading);

export const selectTransactionsDataLoading = createSelector(selectTransactionsState, (state: State) => state.dataLoading);

export const selectTransactionsDates = createSelector(selectTransactionsState, (state: State) => state.dates);

export const selectTransactionsDatesMin = createSelector(
  selectTransactionsDates,
  (dates?: DatesInterval) => {
    const formattedDate = dates ? moment.utc(dates.min).format('YYYY-MM-DD') : undefined;
    return formattedDate;
  }
);

export const selectTransactionsDatesMax = createSelector(
  selectTransactionsDates,
  (dates?: DatesInterval) => {
    const formattedDate = dates ? moment.utc(dates.max).format('YYYY-MM-DD') : undefined;
    return formattedDate;
  }
);

export const selectTransactionsMobileState = createSelector(selectTransactionsState, (state: State) => state.mobile);

export const selectTransactionsMobilePagination = createSelector(selectTransactionsState, (state: State) => state.mobilePagination);

export const selectTransactionsFilter = createSelector(selectTransactionsState, (state: State) => state.filter);

//export const selectTransactionsFilterFunds = createSelector(selectTransactionsFilter, (state: TransactionsFilter) => state.funds);
export const selectTransactionsFilterFunds = createSelector(selectTransactionsFilter, (state: TransactionsFilter) => {
  return state.funds;
});

export const selectTransactionsFilterFrom = createSelector(selectTransactionsFilter, (state: TransactionsFilter) => state.from);

export const selectTransactionsFilterTo = createSelector(selectTransactionsFilter, (state: TransactionsFilter) => state.to);

export const selectTransactionsDetails = createSelector(selectTransactionsState, (state: State) =>
  state.details
);

export const selectTransactionsForPDFDetails = createSelector(selectTransactionsState, (state: State) => state.forPDF.data);
export const selectTransactionsDetailsPagination = createSelector(selectTransactionsState, (state: State) => state.pagination);

export const selectTransactionsDetailsTotal = createSelector(
  selectTransactionsDetails,
  (state: TransactionsDetailsResponsePayload) => state.total
);

export const selectTransactionsDetailsData = createSelector(
  selectTransactionsDetails,
  (state: TransactionsDetailsResponsePayload) =>
    state.data && state.data.length ? state.data[0] : undefined

);

export const selectTransactionsDetailsFund = createSelector(
  selectTransactionsDetailsData,
  (state?: TransactionsData) => !!state ? state.fund : undefined
);

export const selectTransactionsDetailsTransactions = createSelector(
  selectTransactionsDetailsData,
  (state?: TransactionsData) => !!state ? state.transactions : []
);

export const selectTransactionsLoadPayload = createSelector(
  selectTransactionsFilterFrom,
  selectTransactionsFilterTo,
  (from: string, to: string) => {
    if (!from || !to) {
      return undefined;
    }
    return {
      from: formatDateUTC(from),
      to: formatDateUTC(to)
    };
  }
);
